<template>
  <a-card
    :tab-list="tabs"
    :active-tab-key="searchForm.data.status"
    @tabChange="key => onTabChange(key)">
    <div>
      <div>
        <a-form-model
          label-position="top"
          layout="vertical"
          :model="searchForm.data">
          <a-row :gutter="15">
            <a-col :span="2">
              <a-form-model-item label="订单来源" allowClear>
                <dict-select
                  v-model="searchForm.data.channel"
                  dict-code="WEBSITE_ORDER_CHANNEL"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="3">
              <a-form-model-item :label="$t('BUY_AT')">
                <a-range-picker
                  style="width: 100%"
                  :show-time="{ format: 'HH:mm:ss' }"
                  format="YYYY-MM-DD HH:mm:ss"
                  v-model="searchForm.data.timeScope"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="2">
              <a-form-model-item :label="$t('ORDER_NO')">
                <a-input v-model="searchForm.data.orderNo" allowClear/>
              </a-form-model-item>
            </a-col>
            <a-col :span="2">
              <a-form-model-item :label="$t('telephone')">
                <a-input v-model="searchForm.data.phone" allowClear/>
              </a-form-model-item>
            </a-col>
<!--            <a-col :span="2">-->
<!--              <a-form-model-item :label="$t('出生年月start')">-->
<!--                <a-month-picker placeholder="Select" v-model="searchForm.data.ageTimeScopeStart"/>-->
<!--              </a-form-model-item>-->
<!--            </a-col>-->
<!--            <a-col :span="2">-->
<!--              <a-form-model-item :label="$t('出生年月end')">-->
<!--                <a-month-picker placeholder="Select" v-model="searchForm.data.ageTimeScopeEnd"/>-->
<!--              </a-form-model-item>-->
<!--            </a-col>-->
<!--            <a-col :span="2">-->
<!--              <a-form-model-item :label="$t('金额start')">-->
<!--                <a-input-number :min="0" v-model="searchForm.data.amountStart" type="number" allowClear/>-->
<!--              </a-form-model-item>-->
<!--            </a-col>-->
<!--            <a-col :span="2">-->
<!--              <a-form-model-item :label="$t('金额end')">-->
<!--                <a-input-number :min="0" v-model="searchForm.data.amountEnd" type="number" allowClear controls:false/>-->
<!--              </a-form-model-item>-->
<!--            </a-col>-->
            <a-col :span="2">
              <a-form-model-item :label="$t('国家/地区')">
                <a-input v-model="searchForm.data.area" allowClear/>
              </a-form-model-item>
            </a-col>
            <a-col :span="2">
              <a-form-model-item :label="$t('OPERATION')">
                <a-space>
                  <a-button
                    type="primary"
                    plain
                    icon="search"
                    @click="getOrderList">{{ $t('SEARCH') || '查询' }}
                  </a-button>
                  <a-button
                    type="primary"
                    plain
                    icon="export"
                    @click="exportExcel">{{ $t('EXPORT') || '' }}
                  </a-button>
                  <a-button
                    icon="plus-circle"
                    type="primary"
                    @click="addOrder">{{ $t('ADD') || '添加' }}
                  </a-button>
                </a-space>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </div>
      <a-spin :spinning="table.loading">
        <order-card
          :shipped-order="shippedOrder"
          :to-pay="toPay"
          :view-order-records="viewOrderRecords"
          :edit-order-express="editOrderExpress"
          :refund-order="refundOrder"
          :completed-order="completedOrder"
          :editable="true"
          :order="order"
          :key="order.id"
          v-for="order in table.data"/>
        <a-empty v-if="table.data.length===0"/>
      </a-spin>
      <a-pagination
        v-model="table.query.page"
        :total="table.query.total"
        show-size-changer
        :page-size="table.query.size"
        :pageSizeOptions="['5','20','50','100']"
        @showSizeChange="handleSizeChange"
        @change="handleSizeChange"
      >
        <template slot="buildOptionText" slot-scope="props">
          <span>{{ props.value }}条/页</span>
        </template>
      </a-pagination>
    </div>
    <a-modal
      title="发货信息"
      append-to-body
      :footer="null"
      width="50%"
      v-model="orderExpressForm.visible">
      <website-order-express-list
        v-if="orderExpressForm.visible"
        :order-id="orderExpressForm.data.id"
        :on-submit-handler="closeExpressList"
      />
    </a-modal>
    <a-modal
      :footer="null"
      title="订单信息"
      append-to-body
      :close-on-click-modal="false"
      fullscreen
      v-model="form.visible">
      <website-order-create
        v-if="form.visible"
        :order-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </website-order-create>
    </a-modal>
    <a-modal
      title="支付方式"
      :footer="null"
      width="50%"
      v-model="orderPayForm.visible"
    >
      <website-order-pay
        v-if="orderPayForm.visible"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm"
        :order-id="orderPayForm.data.id"
      />
    </a-modal>
  </a-card>
</template>

<script>
import {
  _queryOrders,
  _completedOrder,
  _refundOrder,
  _shippedOrder,
} from '@/api/websiteOrderApi';
import moment from 'moment';
import OrderCard from '@/components/OrderCardWebsite.vue';
import WebsiteOrderCreate from './WebsiteOrderCreate.vue';
import DictSelect from '@/components/DictSelect.vue';
import WebsiteOrderPay from './WebsiteOrderPay.vue';
import WebsiteOrderExpressList from '@/views/website/orderExpress/WebsiteOrderExpressList.vue';

function exportExcel() {
  const status = this.searchForm.data.status === 'ALL' ? '' : this.searchForm.data.status;
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  window.open(`${process.env.VUE_APP_BASE_URL}/website-orders/export?status=${status}&sort=${this.table.sort.prop}&id=${this.searchForm.data.id}&phone=${this.searchForm.data.phone}&orderNo=${this.searchForm.data.orderNo}`);
}

async function getOrderList() {
  this.table.loading = true;
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const timeScope = this.searchForm.data.timeScope && this.searchForm.data.timeScope.length === 2 ? this.searchForm.data.timeScope : [null, null];
  const result = await _queryOrders({
    startAt: timeScope[0] ? moment(timeScope[0]).format('YYYY-MM-DD HH:mm:ss') : null,
    endAt: timeScope[1] ? moment(timeScope[1]).format('YYYY-MM-DD HH:mm:ss') : null,
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    phone: this.searchForm.data.phone,
    orderNo: this.searchForm.data.orderNo,
    channel: this.searchForm.data.channel,
    status: this.searchForm.data.status === 'ALL' ? null : this.searchForm.data.status,
    direction,
  });
  this.table.data = result.content;
  this.table.query.total = result.totalElements;
  this.table.loading = false;
}

function editOrderExpress(orderId) {
  this.orderExpressForm.data.id = orderId;
  this.orderExpressForm.visible = true;
}

function closeExpressList() {
  this.orderExpressForm.data.id = null;
  this.orderExpressForm.visible = false;
  this.getOrderList();
}

function viewOrderRecords(orderId) {
  this.orderRecordForm.data.id = orderId;
  this.orderRecordForm.visible = true;
  this.$router.push(`/website-order/${orderId}/detail`);
}

function toPay(orderId) {
  // 选择支付方式跳转支付 支付宝 微信 第三方
  this.orderPayForm.data.id = orderId;
  this.orderPayForm.visible = true;
}

function closeForm() {
  this.orderPayForm.data.id = null;
  this.orderPayForm.visible = false;
  this.getOrderList();
}

function onTabChange(key) {
  this.searchForm.data.status = key;
  this.table.query.page = 1;
  this.getOrderList();
}

async function refundOrder(orderId) {
  this.$confirm({
    title: '当前操作将使订单状态设为退款，请确认？',
    content: '',
    onOk: async () => {
      await _refundOrder(orderId);
      this.$message.success('申请退款成功');
      this.getOrderList();
    },
  });
}

async function completedOrder(orderId) {
  this.$confirm({
    title: '订单是否已经完成？',
    content: '',
    onOk: async () => {
      await _completedOrder(orderId);
      this.$message.success(this.$t('UPDATE_SUCCESS'));

      this.getOrderList();
    },
  });
}

async function shippedOrder(orderId) {
  this.$confirm({
    title: '是否发货？',
    content: '',
    onOk: async () => {
      await _shippedOrder(orderId);
      this.$message.success(this.$t('UPDATE_SUCCESS'));
      this.getOrderList();
    },
  });
}

function handleSizeChange(current, pageSize) {
  this.table.query.page = current;
  this.table.query.size = pageSize;
  this.getOrderList();
}

function handlePageChange(val) {
  this.table.query.page = val;
  this.getOrderList();
}

function addOrder() {
  this.$router.push('/website-order-add');
}

export default {
  name: 'OrderList',
  components: {
    WebsiteOrderExpressList,
    DictSelect,
    OrderCard,
    WebsiteOrderPay,
    WebsiteOrderCreate,
  },
  data() {
    return {
      tabs: [
        {
          key: 'ALL',
          tab: this.$t('ALL_ORDER'),
        }, {
          key: 'UN_PAID',
          tab: this.$t('UN_PAID'),
        }, {
          key: 'UN_SHIPPED',
          tab: this.$t('UN_SHIPPED'),
        }, {
          key: 'TO_BE_SHIPPED',
          tab: this.$t('TO_BE_SHIPPED'),
        }, {
          key: 'TRANSACTION_COMPLETED',
          tab: this.$t('TRANSACTION_COMPLETED'),
        },
        // {
        //   key: 'APPLY_REFUND',
        //   tab: this.$t('APPLY_REFUND'),
        // },
        // {
        //   key: 'REFUND_COMPLETED',
        //   tab: this.$t('REFUND_COMPLETED'),
        // },
        {
          key: 'CANCEL',
          tab: this.$t('CANCEL'),
        },
      ],
      searchForm: {
        data: {
          channel: '',
          id: '',
          orderNo: '',
          status: 'ALL',
          timeScope: [],
          phone: '',
        },
      },
      orderExpressForm: {
        data: {
          id: null,
        },
        visible: false,
      },
      orderPayForm: {
        data: {
          id: null,
        },
        visible: false,
      },
      orderRecordForm: {
        data: {
          id: null,
        },
        visible: false,
      },
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        loading: false,
        data: [],
        query: {
          page: 1,
          size: 5,
          total: 0,
        },
        sort: {
          prop: 'createAt',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getOrderList,
    editOrderExpress,
    closeExpressList,
    closeForm,
    shippedOrder,
    viewOrderRecords,
    toPay,
    completedOrder,
    handleSizeChange,
    handlePageChange,
    refundOrder,
    onTabChange,
    exportExcel,
    addOrder,
  },
  created() {
    this.getOrderList();
  },
  activated() {

  }
};
</script>

<style scoped>

</style>
